import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

// Interface to define the structure of a News Article object
interface NewsArticle {
  image: string;
  title: string;
  route: string;
}

@Component({
  selector: 'app-relevant-newsarticle',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './relevant-newsarticle.component.html',
  styleUrl: './relevant-newsarticle.component.scss'
})
export class RelevantNewsarticleComponent implements OnInit {

  // This array will hold the 3 random news articles to be displayed
  relevantNewsArticles: NewsArticle[] = [];

  // This is the master list of ALL available news articles
  private allNewsArticles: NewsArticle[] = [
    {
      title: 'GoodFirms Features Kalpita',
      image: '../../../../assets/resources/news-main/goodfirms-pr.webp',
      route: '/kalpita-press-release/goodfirms'
    },
    {
      title: 'Most Influential Business Leaders Shaping the Modern Industry, 2025',
      image: '../../../../assets/resources/news-main/InfluentialBusiness.webp',
      route: '/kalpita-press-release/influential-business'
    },
    {
      title: 'Pioneering AI at Kalpita',
      image: '../../../../assets/resources/news-main/PioneeringAIatKalpita.webp',
      route: '/kalpita-press-release/pioneering-ai'
    },
    {
      title: 'Kalpita 6th Anniversary Celebration',
      image: '../../../../assets/resources/news-main/anniversary-news.webp',
      route: '/kalpita-press-release/kalpita-sixth-anniversary'
    },
    {
      title: 'About Kalpita Technologies',
      image: '../../../../assets/resources/news-main/about-kalpita.webp',
      route: '/kalpita-press-release/about-kalpita'
    },
    {
      title: 'About CEO',
      image: '../../../../assets/resources/news-main/ceo-kalpita.webp',
      route: '/kalpita-press-release/about-ceo'
    }
  ];

  constructor(private router: Router) { }

  ngOnInit(): void {
    // Get the current active URL to exclude it from the random selection.
    const currentUrl = this.router.url;
    this.selectRandomNewsArticles(currentUrl);
  }

  /**
   * Selects 3 random news articles, excluding the one specified by the currentRoute.
   * @param currentRoute The route of the page currently being viewed.
   */
  private selectRandomNewsArticles(currentRoute: string): void {
    // Filter the master list to EXCLUDE the current page.
    const availableSelections = this.allNewsArticles.filter(article => article.route !== currentRoute);

    // Shuffle the filtered list.
    const shuffled = [...availableSelections].sort(() => 0.5 - Math.random());

    // Take the first 3 items.
    this.relevantNewsArticles = shuffled.slice(0, 3);
  }

  // Handles navigation when a card is clicked.
  navigateTo(route: string): void {
    this.router.navigateByUrl(route);
  }
}